module.exports = __webpack_public_path__ + "img/gina.5923907f.png";